<template>
  <v-card class="mx-auto rounded-card">
    <v-tabs v-model="tab">
      <v-tab v-if="hasAnyRoleRecebedoraNotificacao">Notificações meu usuário</v-tab>
      <v-tab v-if="hasRoleGestorNotificacoes">Notificações gerais</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card class="rounded-card"
                flat>
          <v-card-text>
            <px-config-notificacoes-usuario-tab :user="user"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card class="rounded-card"
                flat>
          <v-card-text>
            <px-config-notificacoes-comprador-tab v-if="hasRoleGestorNotificacoes"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfigNotificacoesUsuarioTab from './ConfiguracaoNotificacoesUsuarioTab.vue';
import ConfigNotificacoesCompradorTab from './ConfiguracaoNotificacoesCompradorTab.vue';

export default {
  computed: {
    ...mapGetters('user', ['user', 'hasRoleComprador', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasRoleAprovadorRequisicao', 'hasRoleGestorNotificacoes']),
    tab: {
      get() {
        return this.$store.getters['painelNotificacao/tab'];
      },
      set(tab) {
        this.$store.dispatch('painelNotificacao/tab', tab);
      },
    },
    hasAnyRoleRecebedoraNotificacao() {
      return this.hasRoleRequisicao
      || this.hasRoleComprador
      || this.hasRoleAprovador
      || this.hasRoleAprovadorRequisicao;
    },
  },
  components: {
    pxConfigNotificacoesUsuarioTab: ConfigNotificacoesUsuarioTab,
    pxConfigNotificacoesCompradorTab: ConfigNotificacoesCompradorTab,
  },
};
</script>
